// src/services/InquiryService.ts

import { IInquiry } from "../types/Inquiry";
import { apiClient } from "./apiClient"; // Importamos el nuevo cliente API

// Eliminamos MOCK_INQUIRIES ya que usaremos la API

/**
 * Obtiene todos los mensajes desde el API de Next.js.
 */
export const getInquiries = async (): Promise<IInquiry[]> => {
    try {
        const data = await apiClient('mensajes', {
            method: 'GET',
        });
        // La API ya devuelve los datos, solo necesitamos asegurarnos que sean IInquiry[]
        return data as IInquiry[];
    } catch (error) {
        console.error("Error al obtener mensajes:", error);
        // En caso de error, puedes devolver un array vacío o relanzar el error
        throw error;
    }
};

/**
 * Elimina un mensaje.
 */
export const deleteInquiry = async (id: number): Promise<boolean> => {
    try {
        // El DELETE a /api/mensajes/[id] devuelve 204 No Content (null en apiClient)
        await apiClient(`mensajes/${id}`, {
            method: 'DELETE',
        });
        return true;
    } catch (error) {
        console.error("Error al eliminar mensaje:", error);
        return false;
    }
};

/**
 * Alterna el estado de Leído/No Leído (usa PATCH).
 */
export const toggleReadStatus = async (id: number, isRead: boolean): Promise<IInquiry | undefined> => {
    try {

        const updatedInquiry = await apiClient(`mensajes/${id}/toggle-read`, {
            method: 'PATCH',
        });

        return updatedInquiry as IInquiry;
    } catch (error) {
        console.error("Error al cambiar estado:", error);
        return undefined;
    }
};